import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "passenger-select__quantity" }
const _hoisted_2 = { class: "suffix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseQuantity = _resolveComponent("BaseQuantity")!
  const _component_PetsConfirmation = _resolveComponent("PetsConfirmation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.name), 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.ageSuffix), 1)
      ]),
      _createVNode(_component_BaseQuantity, {
        id: _ctx.type,
        maxValue: 20,
        minValue: 0,
        name: _ctx.name,
        modelValue: _ctx.inputValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
      }, null, 8, ["id", "name", "modelValue"])
    ]),
    (_ctx.type === 'D' && _ctx.inputValue>0)
      ? (_openBlock(), _createBlock(_component_PetsConfirmation, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}